"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListUsersSortField = void 0;
exports.ListUsersSortField = {
    Email: "email",
    Name: "name",
    Id: "id",
    Idp: "idp",
    IdpRef: "idp_ref",
    CreatedAt: "created_at",
    UpdatedAt: "updated_at",
    LastSeenAt: "last_seen_at",
    Dashboard: "dashboard",
};
